/**
 * Element - Union type for any selectable graph element.
 * Can be either a Node (Individual, SchemaClass) or Edge (Relationship).
 */

import type { Node } from "./Node";
import type { Edge } from "./Edge";

/**
 * Element represents any selectable element in the graph.
 * Used as the type for selectedElement in App state.
 */
export type Element = Node | Edge;

/**
 * Type guard to check if an Element is a Node
 */
export function isNode(element: Element | null | undefined): element is Node {
    if (!element) return false;
    return 'concept' in element && !('subject' in element);
}

/**
 * Type guard to check if an Element is an Edge
 */
export function isEdge(element: Element | null | undefined): element is Edge {
    if (!element) return false;
    return 'subject' in element && 'object' in element;
}
